import React, { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useNavigate } from 'js/hooks/navigate';
import { CommonPopup } from 'js/components/common/popups/CommonPopup';

export const LoginFailedPopup = ({ errorCode, controls }) => {
    const navigate = useNavigate();
    const t = useTranslations('playtech.mobile.system.');
    const onClose = useCallback(() => {
        navigate('/');
    }, [navigate]);

    return (
        <CommonPopup
            onClose={onClose}
            controls={controls}
            title={t('popup.login.error.title')}
            content={t(`popup.login.error.${errorCode}`)}
        />
    );
};
